import { render, staticRenderFns } from "./BillingDetailHandlingIndex.vue?vue&type=template&id=78bf5346&scoped=true&"
import script from "./BillingDetailHandlingIndex.vue?vue&type=script&lang=js&"
export * from "./BillingDetailHandlingIndex.vue?vue&type=script&lang=js&"
import style0 from "./BillingDetailHandlingIndex.vue?vue&type=style&index=0&id=78bf5346&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78bf5346",
  null
  
)

export default component.exports